import { useMemo, useState, useEffect } from 'react';
import { getHasCompletedCampaignsOnboardingTourFromMOUISuperStore } from '../api/superstore';
export default function useShouldDisplayTourLinkOnCampaignSelect() {
  const [hasCompletedCampaignsOnboardingTour, setHasCompletedCampaignsOnboardingTour] = useState(false);
  const [loadingHasCompletedCampaignsOnboardingTour, setLoadingHasCompletedCampaignsOnboardingTour] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoadingHasCompletedCampaignsOnboardingTour(true);
    getHasCompletedCampaignsOnboardingTourFromMOUISuperStore().then(value => {
      setHasCompletedCampaignsOnboardingTour(value);
    }).catch().finally(() => {
      setLoadingHasCompletedCampaignsOnboardingTour(false);
    });
  }, []);
  return useMemo(() => !hasCompletedCampaignsOnboardingTour && !loadingHasCompletedCampaignsOnboardingTour, [hasCompletedCampaignsOnboardingTour, loadingHasCompletedCampaignsOnboardingTour]);
}